// import { useState, useEffect, useContext } from 'react'
import { NewsItemInterface } from './NewsItem.interface'
import { Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { Heading, Paragraph } from 'src/components/atoms'
import { paragraphDef, paragraphRoleTypes } from 'src/app-types'

// @ts-ignore
import Fade from 'react-reveal/Fade'
import { getNewsDate } from 'src/lib/Generic'

const NewsItem = ({ testID, item, language = 'en', index = 0 }: NewsItemInterface) => {
    const title = language === 'nl' ? item.title_nl : item.title_en
    //  const intro = language === 'nl' ? item?.intro_nl : item?.intro_en
    const content = language === 'nl' ? item.content_nl : item.content_en

    const renderLink = () => {
        const prompt = language === 'nl' ? 'lees meer' : 'read more'
        if (!content) return null

        return (
            <Link preventScrollReset={false} to={`/news/${item.slug}`}>
                {prompt}
            </Link>
        )
    }

    const __constructImage = (url: string) => {
        return `https://cms.krewinkel.nl/${url}`
    }

    const intro = language === 'nl' ? item.intro_nl : item.intro_en
    const n = item?.date ? item.date : 0

    return (
        <Fade duration={index * 350} distance={'20px'} bottom>
            <div data-testid={testID} className={`NewsItem`}>
                <Row>
                    <Col md={3} className={'img-col'}>
                        <img src={__constructImage(item?.img?.path)} className={'hide-small'} alt={title} />
                    </Col>
                    <Col md={9}>
                        <Heading type={'h6'} text={n as string} />
                        <Heading type={'h5'} text={title} />
                        <Paragraph type={paragraphDef.markdown} content={intro} role={paragraphRoleTypes.small} />
                        {renderLink()}
                    </Col>
                </Row>
            </div>
        </Fade>
    )
}

export default NewsItem
